<template>
  <div>
    <v-dialog
      v-model="isShowRemoveUserModal"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Remove User</h3>
        </v-card-title>
        <v-card-text>
          <p>
            You have chosen to remove access to the User Group <strong>{{ userGroup.userGroupName }}</strong> for the user <strong>{{ userInformation.userUID }}</strong>.
            Please confirm that this user should no longer have access to this group by clicking the <strong class="yes-remove-button">Yes, Remove button</strong>.
          </p>
          <p>If you clicked Remove by mistake, click the <strong class="no-remove-button">No, Don't Remove button</strong> and you will be returned to your task.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" @click.stop="isShowRemoveUserModal=false">No, Don't Remove</v-btn>
          <v-btn color="primary" @click.stop="removeSelectedUser">Yes, Remove</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'manage-users-remove-user-modal',
  computed: {
    ...mapState('manageUsers', ['showRemoveUserModal', 'selectedUserGroupInfo', 'selectedUser']),
    isShowRemoveUserModal: {
      get() {
        return this.showRemoveUserModal
      },
      set(value) {
        this.setShowRemoveUserModal(value)
      }
    },
    userGroup: {
      get() {
        return this.selectedUserGroupInfo
      }
    },
    userInformation: {
      get() {
        return this.selectedUser
      }
    }
  },
  methods: {
    ...mapActions('manageUsers', ['delUserGroupForUser']),
    ...mapMutations('manageUsers', ['setShowRemoveUserModal']),
    removeSelectedUser() {
      const data = {
        user: this.userInformation,
        group: this.userGroup
      }
      this.delUserGroupForUser(data)
      this.isShowRemoveUserModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .yes-remove-button {
    color: $color-primary;
  }

  .no-remove-button {
    color: $color-danger;
  }
</style>
